<template>
    <v-footer color="primary" :dark="current_tenant.DarkMode" class="q-footer">
        <v-row>
          <v-col cols="12" sm="6" md="5" class="py-0">
            <div  v-if="user.currentSetTenant" style="opacity: .5;">{{user.currentSetTenant}} <span class="overline">- Powered by Quility HQ</span></div>
          </v-col>
          <v-col cols="6" sm="2" class="py-0 d-flex align-center" :class="{'justify-center': $vuetify.breakpoint.mdAndUp}">
            <div style="opacity: .5;">{{version}}</div>
          </v-col>
          <v-col cols="6" sm="4" md="5" class="py-0 d-flex align-center justify-end">
            <span style="opacity: .5;">&copy; 2022</span>
          </v-col>
            <!--<router-link to="/page/hq-release-notes">Release Notes</router-link>//-->
        </v-row>
    </v-footer>
</template>
<script>
import ReleaseMeta from '@/ReleaseMeta.json'

export default {
    data() {
        return {
            showBanner: true,
            version: ReleaseMeta.Version + "r" + ReleaseMeta.MinorVersion,
        }
    }
}
</script>
